import { motion } from "framer-motion"
import { Star, ScrollText, Trophy, ArrowRight } from "lucide-react"
import "./TopUniversities.css"

const TopUniversities = ({ countryData }) => {
  const universities = countryData?.topUniversities || []

  return (
    <div className="universities-container">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        Top Universities to Study in {countryData?.name}
      </motion.h1>

      <div className="universities-grid">
        {universities.map((university, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
            viewport={{ once: true }}
            className="university-card"
          >
            <div className="university-header">
              <div className="university-logo-info">
                <img
                  src={university.logo || "/placeholder.svg"}
                  alt={university.name}
                  className="university-logo"
                />
                <div className="university-info">
                  <h3 className="university-name">{university.name}</h3>
                  <p className="university-location">{university.location}</p>
                </div>
              </div>
              <button className="favorite-btn">
                <Star size={20} color="rgba(255,255,255,0.2)" />
              </button>
            </div>

            <div className="university-details">
              <div className="detail-item">
                <div className="detail-icon">
                  <ScrollText size={18} />
                </div>
                <div className="detail-content">
                  <p className="detail-label">Minimum IELTS</p>
                  <p className="detail-value">{university.ielts || "6.0"}</p>
                </div>
              </div>

              <div className="detail-item">
                <div className="detail-icon" style={{ background: 'rgba(168, 85, 247, 0.1)', color: '#a855f7' }}>
                  <Trophy size={18} />
                </div>
                <div className="detail-content">
                  <p className="detail-label">World Ranking</p>
                  <p className="detail-value">#{university.ranking || "N/A"}</p>
                </div>
              </div>
            </div>

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="apply-now-btn"
            >
              Apply Now
            </motion.button>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        className="find-university-container"
      >
        <button className="find-university-btn">
          Find Your Dream University
          <ArrowRight size={20} />
        </button>
      </motion.div>
    </div>
  )
}

export default TopUniversities
